import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-success-modal-dialog',
  templateUrl: './success-modal-dialog.component.html',
  styleUrls: ['./success-modal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessModalDialogComponent {
  public title: string;
  public isImpaired: boolean;
  public icons = CustomIcons;
  public appealId: string;
  constructor(private dialogRef: MatDialogRef<SuccessModalDialogComponent>) {}

  public close(): void {
    this.dialogRef.close();

    /*   const params = this.activeRoute.snapshot.queryParams;
    const catalogItemGlobalId = params?.catalogItemGlobalId;
    const isBackHome = params?.isBackHome;
    const catalogGlobalId = params?.catalogGlobalId;

    let backUrl = `/data/item/${catalogGlobalId}/catalogItems`;
    let queryParams: any = {};

    if (catalogItemGlobalId) {
      queryParams = { objectId: catalogItemGlobalId };
    }

    const currentCatalog = this.store.selectSnapshot(CatalogItemsState.getCatalogItem).call(this, +catalogGlobalId);
    if (isBackHome && isBackHome === 'true') {
      backUrl = '/';
      queryParams = {
        catalogItemGlobalId: catalogItemGlobalId,
        catalogGlobalId: catalogGlobalId
      };
    }

    if (currentCatalog && currentCatalog.isDynamic !== undefined) {
      queryParams = {
        isDynamic: currentCatalog.isDynamic
      };
    }

    if (currentCatalog && currentCatalog.pageSize && (currentCatalog.pageIndex || currentCatalog.pageIndex === 0)) {
      queryParams = {
        ...queryParams,
        pageSize: currentCatalog.pageSize,
        pageIndex: currentCatalog.pageIndex
      };
    }

    this.router.navigate([backUrl], {
      queryParams: queryParams
    }); */
  }
}
